<script setup>
import { defineProps } from "vue";

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: "",
    },
});
</script>

<template>
    <nav class="bg-white w-full relative">
        <div
            class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between py-2 relative"
        >
            <div class="flex items-center">
                <a href="/">
                    <img
                        src="/logo/logo.png"
                        alt="Amana Logo"
                        class="h-10 sm:h-12"
                    />
                </a>
            </div>
            <div
                v-if="title"
                class="absolute left-1/2 transform -translate-x-1/2 text-center"
            >
                <p
                    class="text-gray-700 text-base sm:text-lg font-semibold md:text-xl"
                >
                    {{ title }}
                </p>
            </div>
        </div>

        <div class="w-full h-px bg-gray-300"></div>
    </nav>
</template>
